import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import { TXTWCL_N0_in_Switzerland___exclusivel_ELL } from './RegulatoryHeaderCH.messages.json';
import styles from './RegulatoryHeaderCH.scss';
import RegulatoryIcon from './assets/davos.svg';

const RegulatoryHeaderCZ: React.FC = () => {
  const davosUrl = useResolver(ResolverTag.Davos);

  return (
    <div className={styles.regulatoryHeader}>
      <p className={styles.translation}>
        <Translation
          values={{ 0: 'PokerStars.ch' }}
          {...TXTWCL_N0_in_Switzerland___exclusivel_ELL}
        />
      </p>
      <a href={davosUrl} target="_blank" rel="noopener noreferrer">
        <RegulatoryIcon className={styles.regulatoryIcon} />
      </a>
    </div>
  );
};

export default RegulatoryHeaderCZ;
